import "./svg/nav-savings.svg"

export default {
    name: "nav-savings",
    viewBox: "24 24",
}
